import $http from '@vue-util/http';

import { API_DOMAIN_CONFIGS } from '../../src/constants/SalesFloor';

export default function useRequest({ type = '', entryPoint = '', ...customOptions }) {
  const {
    settings = {}, paths = {}, domains = {}, onSuccess = () => null, onError = () => null,
  } = { ...API_DOMAIN_CONFIGS[type], ...customOptions };
  const api = $http.create({ baseURL: domains?.[entryPoint] || '' });
  const getData = async ({ path = '', pathType = '' }) => api.get(`${ path || paths[pathType] || ''}`, { ...settings }).then(onSuccess).catch(onError);

  return {
    getData,
  };
}
